import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import Form from '../components/McqThemeForm';
import {MCQ_THEME_CONSTRAINS} from 'constants/adminPupups';

const ADD_MCQ_THEME_API = '/api/v1/themes';

@inject('mcqThemesStore')
@inject('alertStore')
@observer
class Add extends PureComponent {
  componentDidMount() {
    const {mcqThemesStore} = this.props;
    mcqThemesStore.initNewMcqTheme();
  }

  validationProcess = resource => {
    let errors = validate(resource, MCQ_THEME_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {mcqThemesStore} = this.props;
    const mcq_theme = _.assign({}, mcqThemesStore.mcq_theme);
    const errors = this.validationProcess(mcq_theme);

    mcqThemesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', mcq_theme.title);

    new HttpClient().multipart(ADD_MCQ_THEME_API, formData, 'POST').then(data => {
      mcqThemesStore.saveMcqTheme(data.body.data.theme);
      mcqThemesStore.initNewMcqTheme();
      this.props.alertStore.success('You successfully created MCQ Theme');
      this.props.history.push('/mcq-themes');
      
    }).catch(() => {
      this.props.alertStore.error('Something went wrong');
    });
  };

  render() {
    return (
      <PageWrapper>
        <Form submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqThemes/containers/Add.js